module.exports = __webpack_public_path__ + "img/width-narrow.72fdb20.jpg";